// Removed EsriMap and GoogleMap imports to avoid circular dependencies
import { FsMap } from '@lib/geo/map';

import { isEsriMap } from './determine-map';

export class FsPointToMap {
  public coords: {
    lat: number;
    lng: number;
  };

  /**
   * Values needed to convert screen point to map point
   * @param values - Values needed to convert screen point to map point
   */
  constructor(
    private readonly values: {
      // Since not every map has been converted to FsMap, we have a fallback to GoogleMap to let the app compile
      // https://taserintl.atlassian.net/browse/FWX-889
      map: FsMap | any;
      x: number;
      y: number;
    },
  ) {
    // Since not every map has been converted to FsMap, we have a fallback to GoogleMap to let the app compile
    // https://taserintl.atlassian.net/browse/FWX-889
    const map: FsMap | any = this.values.map;
    if (isEsriMap(map)) {
      this.coords = this._handleEsri(map);
    } else {
      this.coords = this._handleGoogle(map);
    }
  }

  // Handle Converting Screen Point to Map Point for Esri Maps
  private _handleEsri(map: any): {
    lat: number;
    lng: number;
  } {
    const mapView = map.mapView.toMap({
      x: this.values.x,
      y: this.values.y,
    });
    return {
      lat: mapView.latitude,
      lng: mapView.longitude,
    };
  }

  // Handle Converting Screen Point to Map Point for Google Maps
  private _handleGoogle(map: any): {
    lat: number;
    lng: number;
  } {
    const northEast = map.mapInstance.getBounds().getNorthEast();
    const topRight = map.mapInstance.getProjection().fromLatLngToPoint(northEast);
    const southWest = map.mapInstance.getBounds().getSouthWest();
    const bottomLeft = map.mapInstance.getProjection().fromLatLngToPoint(southWest);
    const scale = Math.pow(
      2,
      (this.values.map.mapInstance as unknown as google.maps.Map).getZoom(),
    );
    const worldPoint = new google.maps.Point(
      this.values.x / scale + bottomLeft.x,
      this.values.y / scale + topRight.y,
    );
    const coordinates = (this.values.map.mapInstance as unknown as google.maps.Map)
      .getProjection()
      .fromPointToLatLng(worldPoint);
    return {
      lat: coordinates.lat(),
      lng: coordinates.lng(),
    };
  }
}
